import React from 'react'
import ReactDOM from 'react-dom'
// // import registerServiceWorker from './registerServiceWorker';
import ApolloClient, { /* createNetworkInterface */ } from 'apollo-boost'
// import { createNetworkInterface } from 'apollo-upload-client'
import { ApolloProvider, browserHistory } from 'react-apollo'
import { BrowserRouter as Router } from 'react-router-dom'
import { LocaleProvider } from 'antd'
import { GraphQLClient, ClientContext } from 'graphql-hooks'
import enUS from 'antd/lib/locale-provider/en_US'

import 'antd/dist/antd.css'
import RouterApp from './Router'
import './index.css'

const clientResults = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_URI,
})

const clientRace = new GraphQLClient({
  url: process.env.REACT_APP_RACE_API,
})

ReactDOM.render(
  <LocaleProvider locale={enUS}>
    <ApolloProvider client={clientResults}>
      <ClientContext.Provider value={clientRace}>
        <Router history={browserHistory}>
          <RouterApp />
        </Router>
      </ClientContext.Provider>
    </ApolloProvider>
  </LocaleProvider>
  , document.getElementById('root')
)
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js